export default "__VITE_ASSET__DJR5BJrZ__"